import {makeVar, useReactiveVar} from '@apollo/client';
import {Principal} from "@betrue/shared/interfaces";
import {useCurrentUser} from "@betrue/front/profile";


const GIVEN_NAME_CLAIM = 'given_name'
const FAMILY_NAME_CLAIM = 'family_name'
const EMAIL_CLAIM = 'email'

const msgInitialValue: Principal = {refreshToken: undefined, sub: undefined, token: undefined, parsedToken: undefined}

export const principalVar = makeVar<Principal>(msgInitialValue)

export const usePrincipal = (): [Principal, (p: Principal) => void] => {
  const [currentUser, setCurrentUser] = useCurrentUser()
  return [useReactiveVar<Principal>(principalVar), (p: Principal) => {
    setCurrentUser({
      ...currentUser,
      email: p.parsedToken[EMAIL_CLAIM],
      firstName: p.parsedToken[GIVEN_NAME_CLAIM],
      lastName: p.parsedToken[FAMILY_NAME_CLAIM]
    })
    principalVar(p)
  }]
}
